export default function getUserPoolId(state) {
  if (state.loginForm && state.loginForm.userPoolId) {
    return state.loginForm.userPoolId;
  }
  return "";
}